<template>
  <div>
    <h3 v-if="mw && mw.title" class="mb-4">{{ mw.title }}</h3>
    <template v-if="mw && mw.content">
      <p v-for="(t, i) in mw.content" :key="i" class="mb-2">{{ t }}</p>
    </template>
    <div>
      <!-- Сайдбар секций -->
      <div style="position: absolute; bottom: 0; top: 0; left: 0; overflow: auto; width: 240px; border-right: 1px solid #ddd">
        <div class="sidebar-scroll">
          <v-list dense shaped>
            <v-list-item
              v-for="section in sections"
              :key="section.section_id"
              :value="section.section_id"
              @click="selected = section.section_id"
              :class="{ 'grey lighten-3': selected === section.section_id }"
            >
              <v-list-item-content>
                <v-list-item-title>{{ section.section_title }}</v-list-item-title>

                <v-list-item-subtitle> {{ answeredCount(section) }} / {{ section.items.length }} отвечено </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </div>
      </div>
      <div style="position: absolute; bottom: 0; top: 0; left: 240px; right: 0; overflow: auto">
        <!-- ВНЕШНИЙ КОНТЕЙНЕР С ФЛЕКСОМ -->
        <!-- ПРОКРУЧИВАЕМАЯ ЧАСТЬ -->
        <div class="questions-scroll" v-if="activeSection">
          <div class="pa-4">
            <h3>{{ activeSection.section_title }}</h3>
            <p class="grey--text">{{ activeSection.section_description }}</p>
            <div>
              <v-row no-gutters>
                <v-col v-for="item in activeSection.items" :key="item.id" :cols="item.size || 12" v-if="isVisible(item)" class="py-0">
                  <div class="pa-1 mb-1">
                    <!-- Описание -->
                    <div v-if="item.description" class="grey--text text--darken-1 mb-2">
                      {{ item.description }}
                    </div>
                    <!-- LABEL (просто текст) -->
                    <div v-if="item.type === 'label'" class="text-h6 font-weight-medium mb-0">
                      {{ item.label || item.text }}
                    </div>
                    <!-- TEXT -->
                    <v-text-field v-else-if="item.type === 'text'" :label="item.label" v-model="answers[item.id]" outlined dense hide-details />

                    <!-- NUMBER -->
                    <v-text-field v-else-if="item.type === 'number'" :label="item.label" v-model.number="answers[item.id]" type="number" outlined dense hide-details />

                    <!-- TEXTAREA -->
                    <v-textarea
                      v-else-if="item.type === 'textarea'"
                      :label="item.label"
                      :placeholder="item.placeholder"
                      v-model="answers[item.id]"
                      outlined
                      dense
                      auto-grow
                      hide-details
                    />

                    <!-- SELECT -->
                    <v-select v-else-if="item.type === 'select'" :label="item.label" :items="item.options" v-model="answers[item.id]" outlined dense hide-details />

                    <!-- MULTISELECT -->
                    <v-select
                      v-else-if="item.type === 'multiselect'"
                      :label="item.label"
                      :items="item.options"
                      v-model="answers[item.id]"
                      multiple
                      small-chips
                      hide-selected
                      dense
                      outlined
                      hide-details
                      deletable-chips
                    />

                    <!-- RADIO -->
                    <div v-else-if="item.type === 'radio'">
                      <legend class="v-label">
                        {{ item.label }}
                      </legend>
                      <v-radio-group v-model="answers[item.id]" row dense class="mt-0">
                        <v-radio v-for="opt in item.options" :key="opt" :label="opt" :value="opt" />
                      </v-radio-group>
                    </div>
                    <!-- RANGE SLIDER -->
                    <div v-else-if="item.type === 'range'">
                      <!-- метки слева и справа -->
                      <div class="d-flex justify-space-between text-caption mb-1">
                        <span>{{ item.labels?.[0] }}</span>
                        <span>{{ item.labels?.[1] }}</span>
                      </div>

                      <v-slider v-model="answers[item.id]" :min="item.min" :max="item.max" :step="item.step" thumb1-label="always" class="mt-3">
                        <template v-slot:append>
                          <span v-if="item.unit">{{ answers[item.id] }}{{ item.unit }}</span>
                        </template>
                      </v-slider>
                    </div>
                    <!-- fallback: Показать ошибку для неизвестного типа -->
                    <div v-else class="red--text">Неизвестный тип поля: {{ item }}</div>
                  </div>
                </v-col>
              </v-row>
            </div>
          </div>
        </div>
      </div>
    </div>
    <s-tree-block :value="wizard" v-if="getAccess('contract.wizard.debug')" />
    <portal to="v-wizard-action">
      <v-btn v-if="!readonly" @click="onUndo" class="mr-2">Назад</v-btn>
      <v-btn @click="onNext">Далее</v-btn>
    </portal>
  </div>
</template>

<script>
import { getForm, submitForm, removeEl, genModel, getAccess } from "@/components/mixings";
//import questionnaire from "./questionnaire";

export default {
  components: {},
  mixins: [getForm, submitForm, removeEl, genModel, getAccess],
  props: {
    wizard: {
      type: Object,
      default: () => {},
    },
    mw: {
      type: Object,
      default: () => {},
    },
    defaults: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      selected: null, // текущая выбранная секция
      answers: {},
      services: [],
      services_: [],
      model: [],
      data: {},
      loaded: true,
      questionnaire: this.$store.getters["config/get"].models.dir_questionnaire,
    };
  },
  computed: {
    activeSection() {
      return this.sections.find(s => s.section_id === this.selected);
    },
    sections() {
      console.log("questionnaire", this.questionnaire);
      return this.questionnaire;
      return (questionnaire || []).map(q => {
        return { section_id: q.section_id, title: q.section_title, name: q.section_id };
      });
    },
    readonly() {
      return !!this.wizard?.estimate?.id || !!this.wizard?.contract?.template_id;
    },
    m() {
      return this.mw; //.wizardContract;
    },
    config() {
      return this.mw?.config || {}; //.wizardContract;
    },
  },
  created() {
    this.init();
  },
  watch: {
    services(v) {},
  },
  methods: {
    answeredCount(section) {
      return section.items.filter(q => this.answers[q.id]).length;
    },
    waitForEvent(eventName, payload) {
      return new Promise(resolve => {
        this.$emit(eventName, payload, resolve);
      });
    },
    init() {
      this.loaded = !true;
      if (this.sections.length) {
        this.selected = this.sections[0].section_id;
      }
      this.answers = Object.assign({}, this.wizard?.questionnaire?.answers || {});
      //     this.services = this.services_ || [];
      //  this.calcModel();
      //  this.applyData({ services: this.services });
      this.loaded = true;
    },
    updateData() {},

    calcModel(t) {
      return;
      const config = this.config;
      let model = this.calcModelConfig(config);

      this.fillFormFromModel(model);
      this.model = model;
      return model;
    },
    async onUndo() {
      await this.waitForEvent("save", {});
      this.$emit("next", -1);
    },
    async onNext() {
      const result = await this.waitForEvent("save", { answers: this.answers });
      this.isChanged = false;
      this.$emit("next");
    },
    isVisible(item) {
      if (!item.show_if) return true;

      const { field, contains } = item.show_if;
      const value = this.answers[field];

      if (!value) return false;

      if (Array.isArray(value)) {
        return value.includes(contains);
      }

      return value === contains || String(value).includes(contains);
    },
  },
};
</script>
<style scoped>
.sidebar-scroll {
  flex: 1;
  overflow-y: auto;
  min-height: 0; /* критично! */
}

.questions-scroll {
  flex: 1;
  overflow-y: auto;
  min-height: 0; /* критично! */
}
</style>
